<div class="menu-tab-container">
  <list-menu
  [merchant]="merchant">
  </list-menu>

  <div class="categories-container" *ngIf="products.isNotEmpty()">
    <div class="category-item-container"
         [class.primary-background-color]="selectedCategory === 'all'"
         (click)="filterByCategory('all')">
      <p class="category-item"
         [style.color]="selectedCategory === 'all' ? '#FFF !important' : '#443F3F !important'"
         i18n="@@all">
        All
      </p>
    </div>
    <div class="category-item-container" *ngFor="let category of merchant?.categories"
         [class.primary-background-color]="selectedCategory === category.id"
         (click)="filterByCategory(category.id)">
      <p class="category-item"
         [style.color]="selectedCategory === category.id ? '#FFF !important' : '#443F3F !important'">
        {{ category.name }}
      </p>
    </div>
  </div>
  <div *ngIf="products.isNotEmpty()">
    <div class="product-items">
      <div *ngFor="let product of products">
        <product-item [product]="product"></product-item>
      </div>
    </div>
    <primary-button
      *ngIf="showLoadMoreButton"
      class="load-more-button"
      (onClick)="loadMore()"
      [loading]="loading"
      [enableKeyboardEvent]="false"
      title="{{loadMoreProductsLabel}}">
    </primary-button>
  </div>
  <div class="empty-state" *ngIf="products.isEmpty()">
    <div>
      <img src="assets/menu-empty-state.svg">
    </div>
    <div class="empty-state-title">
      <p i18n="@@emptyMenuTitle">Menu Coming Soon</p>
    </div>
    <div class="empty-state-message">
      <p i18n="@@emptyMenuSubtitle">This restaurant hasn’t added their menu yet, but we’re sure it’ll be worth the wait!</p>
    </div>
  </div>
</div>
